<template>
  <div class="column" :class="`column_${size} align_${align}${mobile ? '' : ' mobile_hidden'}`">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default: "1",
    },
    align: {
      type: String,
      default: "left",
    },
    mobile: {
      type: Boolean,
      default: true
    }
  },
}
</script>

<style lang="scss">
.column {
  padding: 0 20px 30px 0;
  position: relative;

  &.align_right {
    text-align: right;
    padding: 0 0 30px 25px;
  }
}
.column_12 {
  width: 100%;
}
.column_10 {
  width: 84%;
}
.column_9 {
  width: 75%;
}
.column_8 {
  width: 66.66%;
}
.column_6 {
  width: 50%;
}
.column_4 {
  width: 33.33%;
}
.column_3 {
  width: 25%;
}
.column_2 {
  width: 16.66%;
}
.column_1 {
  width: 8.33%;
}
@media (max-width: 767px) {
  .column {
    width: 100%;
    padding: 0 5px 20px;
  }
  .column_2 {
    width: 50%;
  }
  .mobile_hidden {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// Column.vue?540c5f50